import MaestrosScreen from "../../Screen/ERP/IMEX/MaestrosScreen";


export const IMEX = [
    {
        path: "IMEX/Maestros",
        permiso: 116,
        element: <MaestrosScreen />,
    },
];
  
export default IMEX;
  